
import { BookingWindow, IGenericError } from '@libs/entity-lib';
import { createReducer, on } from '@ngrx/store';
import * as fromCustomer from './booking-window.actions';

export interface State {
    loading: boolean;
    bookingWindow: BookingWindow | null;
    error: IGenericError | null;
}

export const initialState: State = {
    loading: false,
    error: null,
    bookingWindow: null
  };


export const reducer = createReducer(
  initialState,
  on(fromCustomer.fetchBookingWindow, (state) =>  ({ ...state, loading: true, error: null })),
  on(fromCustomer.fetchBookingWindowSuccessfuly, (state, { bookingWindow }) => ({
    ...state,
    loading: false,
    error: null,
    bookingWindow
  })),
  on(fromCustomer.fetchBookingWindowFailed, (state, { error }) =>  ({ ...state, loading: false, error }))

  ,
  on(fromCustomer.updateBookingWindow, (state) =>  ({ ...state, loading: true, error: null })),
  on(fromCustomer.updateBookingWindowSuccessfuly, (state, { bookingWindow }) => ({
    ...state,
    loading: false,
    error: null,
    bookingWindow
  })),
  on(fromCustomer.updateBookingWindowFailed, (state, { error }) =>  ({ ...state, loading: false, error })),
);
